<template>
    <transition name="fade">
        <div v-if="isOpen" class="download-report-modal">
            <div v-on-clickaway="closeModal" class="modal-content relative">
                <div class="modal-header">
                    <h5 class="modal-title shadow-text-none">{{ $t('report_modal_header_save') }}</h5>
                    <div class="text-right">
                        <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                    </div>
                </div>
                <div class="modal-body text-center">
                    <select v-model="fileType" @change="sendToDrive(fileType)" class="report-select mb-4">
                        <option value="pdf" selected>PDF</option>
                        <option value="xlsx" selected>XLSX</option>
                    </select>
                    <div class="load-selected-group">
                        <div v-if="fileType == 'pdf'" class="col-6 download-file">
                            <a
                                :href="file.url"
                                class="load-selected-btn text-dark-charcoal font-size-18 uppercase flex items-center font-bold no-underline cursor-pointer shadow-text-none"
                                target="_blank"
                                ref="downloadLink_pdf"
                            >
                                <i class="blobk-icon fas fa-file-pdf text-2xl mr-2"></i>
                                <div class="blobk-name">{{ $t('report_modal_button_pdf') }}</div>
                            </a>
                        </div>
                        <div v-if="fileType == 'xlsx'" class="col-6 download-file">
                            <a
                                :href="file.urlXlsx"
                                class="load-selected-btn text-dark-charcoal font-size-18 uppercase flex items-center font-bold no-underline cursor-pointer shadow-text-none"
                                target="_blank"
                                ref="downloadLink_xlsx"
                            >
                                <i class="blobk-icon fas fa-file-excel text-2xl mr-2"></i>
                                <div class="blobk-name">{{ $t('report_modal_button_xlsx') }}</div>
                            </a>
                        </div>
                        <div v-if="isDesktop" class="col-6 savedrive-file">
                            <a
                                @click="sendToDrive(fileType)"
                                class="load-selected-btn text-dark-charcoal font-size-18 uppercase flex items-center font-bold no-underline cursor-pointer shadow-text-none"
                            >
                                <i class="blobk-icon fab fa-google-drive text-2xl mr-2"></i>
                                <div id="savedrive" class="blobk-name">{{ $t('report_modal_button_drive') }}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import helper from '@/lib/helper.js'
import { directive as onClickaway } from 'vue-clickaway'

export default {
    props: {
        open: {
            type: Boolean,
            default: false
        },

        file: {
            type: Object,
            default: function () {
                return {
                    url: '',
                    filename: '',
                    urlXlsx: '',
                    filenameXlsx: ''
                }
            }
        },

        downloadReport: {
            type: Function
        },

        sendToDrive: {
            type: Function
        }
    },

    directives: {
        onClickaway: onClickaway
    },

    watch: {
        open: function (val) {
            this.isOpen = val

            if (val) {
                this.downloadReport()
            }
        }
    },

    computed: {
        isDesktop() {
            return helper.desktop()
        }
    },

    data() {
        return {
            isOpen: false,
            fileType: 'pdf'
        }
    },

    methods: {
        closeModal() {
            if (this.isLoading == true) {
                return
            }

            this.$emit('close')
        }
    }
}
</script>

<style lang="scss">
.download-report-modal {
    font-family: 'Open Sans', sans-serif !important;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: start;
    font-size: 1.2em;
    z-index: 9999;

    .modal-content {
        background-color: #fff;
        margin-top: 4rem;
        padding: 1rem 1.5rem;
        width: 400px !important;
        overflow: hidden;
        border-radius: 3px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

        @media screen and (max-width: 500px) {
            width: 90% !important;
            margin: 1rem 0.5rem;
        }

        .modal-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .modal-title {
                margin: 0;
                text-transform: uppercase;
            }
        }

        .modal-body {
            padding: 1.5rem 0 1rem 0;

            .load-selected-group {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;

                .load-selected-btn {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 100%;
                    border: 1px solid gray;
                    background-image: linear-gradient(bottom, #ffffff, #e6e6e6);
                    border-radius: 0.6rem;

                    .blobk-name,
                    .blobk-icon {
                        display: block;
                        padding: 0.7rem 0;
                    }

                    .blobk-icon {
                        font-size: 3.5rem;
                    }
                }
            }

            .report-select {
                padding: 0.8rem;
                width: 100%;
                background-color: transparent;
                border: 1px solid #49403e;
                border-radius: 4px;
                font-size: 18px;
                font-weight: bold;
            }
        }
    }

    @for $i from 1 through 12 {
        .col-#{$i} {
            width: calc(#{$i} * 100% / 12);
        }
    }

    .download-loading {
        margin: -1rem 0 0 -1.5rem;
    }

    .download-file {
        padding-right: 0.5rem;
    }

    .savedrive-file {
        padding-left: 0.5rem;
    }
}
</style>